import { svg } from '@rxdi/lit-html';

export function terra() {
  return svg`<?xml version="1.0" encoding="utf-8"?>
  <!-- Generator: Adobe Illustrator 24.3.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
  <svg style="width: 59px;" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1172 886" style="enable-background:new 0 0 1172 886;" xml:space="preserve">
    <style type="text/css">
    .st0{fill:#2845AD;}
    .st1{fill:#5494F8;}
    .st2{fill:none;}
  </style>
    <title>Terra icon</title>
    <path class="st0" d="M461.1,119.9c38.9-16,81.2-21.2,122.9-22.5c62.8,0.8,127.1,8.8,184.4,35.8c45,20.8,82.5,55.1,112.1,94.3
    c-9.3-6.8-14.6-17.8-22.9-25.7c-15.2-14.5-28.8-31.9-48.9-39.8c-19.8-6.8-41.1-8.5-61.9-7.5c-52.1,3.7-102.9,17.7-152,35.2
    c-53.9,21.2-108.1,47.2-148.3,90.1c-8,8-12.7,18.6-20.5,26.7c-18.4-12.5-36.3-27.4-47.2-47.1c-0.5-1-1.6-3.1-2.1-4.2
    c33.8-15.8,66.7-35.2,92.6-62.4c13.4-14.5,25.9-34.8,19-55.1C484.2,126,470.8,124.5,461.1,119.9 M605.5,525.8
    c50.5,18.6,101.5,35.8,153.2,50.7c45.3,12.3,91.6,24.3,138.8,24c-4.9,11.9-10.7,23.4-17.3,34.4c-41.6,13.4-81.5,31.8-118.7,54.8
    c-22.8,14.9-46,31.5-59.4,55.8c-5.4,9.5-5.5,20.7-2.6,30.9c-0.6,0.7-1.8,2-2.3,2.7c-16.2,4.2-33.1,13.2-50,6.7
    c-28.3-9.1-51.6-29.1-71.1-50.8c-23.8-28.2-43.3-62.5-45.7-100c-0.7-35.3,21.3-66.1,47.1-88.1C586.3,539.3,596,532.6,605.5,525.8
    L605.5,525.8z" />
    <path class="st1" d="M429.7,122c10.3-2.5,20.9-1.1,31.4-2c9.7,4.6,23.1,6.1,27.2,17.7c6.8,20.3-5.6,40.6-19,55.1
    c-25.9,27.2-58.8,46.6-92.6,62.4c0.5,1,1.5,3.1,2.1,4.2c-3.9-2.7-8.7-1.2-12.6,0.6c-25.7,11.5-52.5,20.5-80,27
    c-10.6,2.2-21.3,4.5-32.2,3.3c0-6.3,4.4-11.3,7-16.7c26-47.1,62-88,105.4-119.9C385.6,139.9,405.8,125.4,429.7,122 M594.8,189.7
    c49-17.5,99.8-31.5,152-35.2c20.8-1,42.1,0.7,61.9,7.5c20.1,8,33.7,25.4,48.9,39.8c8.3,7.9,13.6,19,22.9,25.7
    c4.8,2.4,6.5,8.4,9.9,12.4c69.4,98.2,85.9,231.2,42.9,343.5c-4.2,15-23,15.6-35.8,17.1c-47.3,0.3-93.5-11.7-138.8-24
    C707,561.6,656,544.4,605.5,525.8c-47.7-18.8-94.1-42.1-134.1-74.5c-25-21.4-48.2-48.2-54.5-81.4c-4.2-17.3-1.6-35.5,4.9-51.8
    c1.6-3.8,4.2-7.4,4.2-11.6c7.9-8.1,12.5-18.7,20.5-26.7C486.7,236.9,540.9,210.9,594.8,189.7 M237.4,325.5l2,0.8
    c15,18.3,30.3,36.5,45.4,54.6c31.8,36.4,59,76.4,84.5,117.4c35.7,55,67.7,115.3,74.2,181.5c0.6,35.7,0.8,71.7-5,107.1
    c-10.3,2.6-20.5-4-29.7-8c-68.7-37-124.8-96.6-158.3-167.2C208.4,523.2,203.4,417.6,237.4,325.5 M880.2,634.9
    c9.1-2.4,18.2-6,27.8-5.6c2.6,6.6-2.4,12.2-5.5,17.6c-30.2,48.8-71.4,90.8-120.3,120.9c-16.4,10.3-33.9,21.7-54,20.7
    c-9.6,0.7-18.9-3.4-26-9.7c-1.2,0.1-3.8,0.3-5,0.4c0.6-0.7,1.8-2,2.3-2.7c-2.8-10.2-2.7-21.5,2.6-30.9
    c13.4-24.3,36.6-40.9,59.4-55.8C798.7,666.7,838.6,648.3,880.2,634.9z" />
    <rect x="186" y="43" class="st2" width="800" height="800" />
  </svg>
  `;
}
